import { createQueryHook } from '~/shared/providers/api';

export interface ExternalRoleUserCountsResult {
  counts: Record<string, number>;
}

export const useExternalRoleUserCountsQuery = createQueryHook(
  'settings.customerPortal.roleUserCounts',
  () => ({
    coreUserRoleAssignments: {
      __args: {
        filter: {
          pagination: {
            limit: 10000,
            offset: 0,
          },
        },
      },
      entries: {
        userId: true,
        role: {
          id: true,
        },
      },
    },
  }),
  {
    select: (data): ExternalRoleUserCountsResult => {
      const entries = data?.coreUserRoleAssignments?.entries ?? [];

      const roleUserSets = new Map<string, Set<string>>();

      entries.forEach((assignment) => {
        const roleId = assignment.role?.id;
        const userId = assignment.userId;
        if (!roleId || !userId) return;

        if (!roleUserSets.has(roleId)) {
          roleUserSets.set(roleId, new Set());
        }
        const roleSet = roleUserSets.get(roleId);
        roleSet?.add(userId);
      });

      const counts: Record<string, number> = {};
      roleUserSets.forEach((users, roleId) => {
        counts[roleId] = users.size;
      });

      return { counts };
    },
  },
);
